export const initialState = {
  fetched: false,
  data: null,
  _default_spec: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'PROJECTED_INCOMES_FETCHED':
      if (action.payload) {
        return { fetched: true, data: action.payload.data, _default_spec: action.payload._default_spec };
      } else {
        return { fetched: true, data: null, _default_spec: null };
      }
    default:
      return state;
  }
}
